<script setup lang="ts">
import { computed, onMounted, onUnmounted } from 'vue'
import { useAppStore } from '@/store/modules/app'
import { ConfigGlobal } from '@/components/ConfigGlobal'
import { useDesign } from '@/hooks/web/useDesign'

const { getPrefixCls } = useDesign()

const prefixCls = getPrefixCls('app')

const appStore = useAppStore()

const currentSize = computed(() => appStore.getCurrentSize)

const greyMode = computed(() => appStore.getGreyMode)

appStore.initTheme()

/** 页面从后台切回时尝试续期 accessToken，避免长时间停留后列表/列配置加载失败 */
const refreshSessionOnVisible = () => {
  if (document.visibilityState !== 'visible') return
  const token = localStorage.getItem('accessToken')
  if (!token) return
  import('@/utils/tokenRefresh').then(({ ensureValidAccessToken }) => {
    ensureValidAccessToken().catch(() => {})
  })
}

onMounted(() => {
  document.addEventListener('visibilitychange', refreshSessionOnVisible)
})

onUnmounted(() => {
  document.removeEventListener('visibilitychange', refreshSessionOnVisible)
})

// 全局清除本地存储的函数
const clearAllAppData = () => {
  try {
    // 清除应用相关的所有本地存储
    const keysToClear = ['isSSO']

    const sso = localStorage.getItem('isSSO')
    // if (sso) {
    //   keysToClear.push('accessToken', 'userInfo')
    // }

    keysToClear.forEach((key) => {
      localStorage.removeItem(key)
    })

    console.log('应用数据已清除')
  } catch (error) {
    console.error('清除应用数据失败:', error)
  }
}

// 监听页面关闭事件
window.addEventListener('beforeunload', () => {
  clearAllAppData()
})
</script>

<template>
  <ConfigGlobal :size="currentSize">
    <RouterView :class="greyMode ? `${prefixCls}-grey-mode` : ''" />
  </ConfigGlobal>
</template>

<style lang="less">
@prefix-cls: ~'@{adminNamespace}-app';

.size {
  width: 100%;
  height: 100%;
}

html,
body {
  padding: 0 !important;
  margin: 0;
  overflow: hidden;
  .size;

  #app {
    .size;
  }
}

.@{prefix-cls}-grey-mode {
  filter: grayscale(100%);
}
</style>
